import React from 'react'
import styles from './styles.module.scss'
import classNames from 'classnames'
import {
  getMTODeliveryDate,
  isTailoredProduct
} from '@components/product/mto/helpers'
import { FulfillmentLocation } from 'types/product'

type FulfillmentConfig = {
  dispatchDays: number
  labelPrefix: string
}

type FulfillmentInfoProps = {
  createdAt?: string
  fulfillment: FulfillmentConfig
  classes?: string
}

export function getFulfillmentConfig({
  sku,
  fulfillmentLocation
}: {
  sku?: string
  fulfillmentLocation?: FulfillmentLocation
}): FulfillmentConfig | null {
  if (fulfillmentLocation === 'TAL') {
    if (isTailoredProduct(sku)) {
      return {
        dispatchDays: 28,
        labelPrefix: 'Estimated dispatch by'
      }
    }

    return {
      dispatchDays: 14,
      labelPrefix: 'Estimated dispatch by'
    }
  }

  return null
}

function FulfillmentInfo({
  createdAt,
  fulfillment,
  classes
}: FulfillmentInfoProps) {
  return (
    <p className={classNames(styles.mtoDispatch__info, classes)}>
      <strong className={styles.mtoDispatch__title}>Made to Order:</strong>{' '}
      {fulfillment.labelPrefix}{' '}
      {getMTODeliveryDate(createdAt, fulfillment.dispatchDays)}
    </p>
  )
}

export default FulfillmentInfo
